import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Info } from 'lucide-react';

export const Layout = ({ children }) => {
  const location = useLocation();

  return (
      <div className="min-h-screen flex flex-col">
        <header className="bg-gray-800 text-white py-3">
          <div className="container mx-auto px-4">
            <div className="flex justify-between items-center">
              <div className="text-xl font-bold">Race game</div>

              <div className="flex space-x-4">
                <Link
                    to="/"
                    className={`flex items-center px-3 py-2 rounded-md transition ${
                        location.pathname === '/'
                            ? 'bg-gray-700 text-white'
                            : 'hover:bg-gray-700'
                    }`}
                >
                  <Home size={18} className="mr-1" />
                  Home
                </Link>

                <Link
                    to="/about"
                    className={`flex items-center px-3 py-2 rounded-md transition ${
                        location.pathname === '/about'
                            ? 'bg-gray-700 text-white'
                            : 'hover:bg-gray-700'
                    }`}
                >
                  <Info size={18} className="mr-1" />
                  About
                </Link>
              </div>
            </div>
          </div>
        </header>

        <main className="flex-grow bg-gray-50">
          {children}
        </main>

        <footer className="bg-gray-800 text-white py-6">
          <div className="container mx-auto px-4">
            <div className="flex justify-between items-center">
              <div>Made by Doobe</div>
              <div className="flex space-x-4">
                <a href="#" className="hover:text-blue-400 transition">Terms</a>
                <a href="#" className="hover:text-blue-400 transition">Privacy</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
  );
};
